import { Grid, Skeleton, Stack } from '@mui/material'
import times from 'lodash/times'

export const ViewPaymentSkeleton = (): React.ReactElement => {
  return (
    <Stack direction="column" gap={5}>
      <Skeleton width="350px" height="54px" />
      <Grid flexDirection="row" container spacing={3}>
        {times(4, (idx) => (
          <Grid item key={`${idx}__view_skeleton}`} xs={12} md={6}>
            <Skeleton width="100%" height="300px" />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}
